export default "__VITE_ASSET__CVhcNn9g__"